module.exports = __webpack_public_path__ + "static/media/nicolas.3d9bf8a8.jpg";